<div class="alert alert-{{type}} fade show" role="alert"
     [ngClass]="cssClass + (closeable ? ' alert-dismissible ' : '')">
  <ng-content></ng-content>
  @if (closeable) {
    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close" tabindex="-1">
    </button>
  }
</div>
